<template>
	<div v-if="expressList.length" class="heading bg-warning pl-1 pb-1 d-print-none">
		<span class="badge">Priority jobs for today:</span><router-link :to="'/ordering/' + job.Job" v-bind:class="[routeColour(job.Route), 'badge', 'ml-2']" v-for="job in expressList" :key="job.Job">{{ job.Job }}</router-link>
	</div>
</template>

<script>
import axios from 'axios'
import RouteNumberToCSS from '../utils/RouteNumberToCSS'

export default {
	name: 'ExpressBanner',
	data: function () {
		return {
			expressList: [],
			errored: false
		}
	},
	methods: {
		routeColour: function (value) {
			return RouteNumberToCSS(value)
		}
	},
	mounted: function () {
		axios
			.get('/api/v1/job/express')
			.then(response => {
				this.expressList = response.data
			}).catch(error => {
				this.errored = error.response ? error.response.data.error : error;
			})
	}
}
</script>
